import { MutationTree } from "vuex";
import { StateSystemSettings } from "@/store/types";
import { MUTATION_TYPES } from "@/lib/const";

export const mutations: MutationTree<StateSystemSettings> = {
  [MUTATION_TYPES.STORE_DATA]: (state, payload) => {
    Object.assign(state, payload);
  }
};
